import { useEffect, useState } from 'react';

/**
 * Gibt `value` erst zurück, wenn er `delay` ms lang stabil geblieben ist.
 *
 * Ersetzt die handgebauten setTimeout/clearTimeout-Paare in den Admin-Masken
 * (Benutzersuche, Listensuche): der Timer hängt am Effekt, wird bei jeder
 * Änderung aufgeräumt und kann deshalb keinen Request einer alten Eingabe
 * mehr nachschieben.
 */
export const useDebouncedValue = (value, delay = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};

export default useDebouncedValue;
